import React, { FC, useEffect } from 'react';
import { DecisionPopover } from '../../popover/DecisionPopover';
import {
  WithRestrictedModalProps,
  withRestrictedModal,
} from '../../../components/modal/components/modal-restricted/withRestrictedModal';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { buildUrlWithParameters } from '../../../utils/url-utils/urlUtils';
import { useUser } from '../../../user/useUser';

type Props = {
  decision: {
    url: string;
    title: string;
    sommaireAnaHtml?: string;
  };
  source: string;
} & WithRestrictedModalProps;

export const RawLegislationSnippetDecisionPopover: FC<Props> = ({
  source,
  decision,
  openRestrictedModal,
}) => {
  const { accessPremium } = useUser();
  useEffect(() => {
    doctrineAnalytics('Search DisplayDecisionPopover');
  }, []);

  const handleClick = () => {
    doctrineAnalytics('Search DecisionPopoverClicked');
    if (!accessPremium) {
      openRestrictedModal('decision_popover');
    }
  };

  return (
    <DecisionPopover
      title={decision.title}
      summary={decision.sommaireAnaHtml}
      handleClick={handleClick}
      href={
        accessPremium
          ? buildUrlWithParameters(decision.url, {
              source,
            })
          : undefined
      }
    />
  );
};

export const LegislationSnippetDecisionPopover = withRestrictedModal(
  RawLegislationSnippetDecisionPopover,
);
